import { FC } from "react";
import Container from "~/components/Container";
import TabReviewsV2 from "~/components/TabReviews/TabReviewsV2";

interface SectionTabReviewsV2Props {}

const SectionTabReviewsV2: FC<SectionTabReviewsV2Props> = () => {
  return (
    <Container>
      <TabReviewsV2 />
    </Container>
  );
};

export default SectionTabReviewsV2;
